import React, { useState } from "react";
import { Link } from "react-router-dom";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Filter from "../Buttons/Filter";
import Actions from "../Buttons/Actions";
import AddNew from "../Buttons/AddNew";
import { BsSearch } from "react-icons/bs";
import { FaBars } from "react-icons/fa";

function DoctorDetails({
                           onSearch,
                           onFilterGender,
                           onFilterSpecialty,
                           onFilterLanguage,
                           onFilterRange
                       }) {
    // estados para todos los filtros
    const [selectedGender, setSelectedGender] = useState("All");
    const [selectedSpecialty, setSelectedSpecialty] = useState("All");
    const [selectedLanguage, setSelectedLanguage] = useState("All");
    const [selectedTelemedicine, setSelectedTelemedicine] = useState("Any");
    const [selectedHouseCalls, setSelectedHouseCalls] = useState("Any");
    const [selectedOnlineBooking, setSelectedOnlineBooking] = useState("Any");
    const [selectedRating, setSelectedRating] = useState("");
    const [range, setRange] = useState([0, 4000]);

    // cuenta de filtros activos
    const getActiveFilterCount = () => {
        let count = 0;
        if (selectedGender !== "All") count++;
        if (selectedSpecialty !== "All") count++;
        if (selectedLanguage !== "All") count++;
        if (selectedTelemedicine !== "Any") count++;
        if (selectedHouseCalls !== "Any") count++;
        if (selectedOnlineBooking !== "Any") count++;
        if (selectedRating !== "") count++;
        if (range[0] !== 0 || range[1] !== 4000) count++;
        return count;
    };

    // lista de chips activos
    const getActiveFilterChips = () => {
        const chips = [];

        if (selectedSpecialty !== "All") {
            chips.push({
                label: `Specialty: ${selectedSpecialty}`,
                onClear: () => setSelectedSpecialty("All"),
            });
        }
        if (selectedGender !== "All") {
            chips.push({
                label: `Gender: ${selectedGender}`,
                onClear: () => setSelectedGender("All"),
            });
        }
        if (selectedLanguage !== "All") {
            chips.push({
                label: `Language: ${selectedLanguage}`,
                onClear: () => setSelectedLanguage("All"),
            });
        }
        if (selectedTelemedicine !== "Any") {
            chips.push({
                label: `Telemedicine: ${selectedTelemedicine}`,
                onClear: () => setSelectedTelemedicine("Any"),
            });
        }
        if (selectedHouseCalls !== "Any") {
            chips.push({
                label: `House Calls: ${selectedHouseCalls}`,
                onClear: () => setSelectedHouseCalls("Any"),
            });
        }
        if (selectedOnlineBooking !== "Any") {
            chips.push({
                label: `Online Booking: ${selectedOnlineBooking}`,
                onClear: () => setSelectedOnlineBooking("Any"),
            });
        }
        if (selectedRating !== "") {
            chips.push({
                label: `Rating: ${selectedRating}+ stars`,
                onClear: () => setSelectedRating(""),
            });
        }
        if (range[0] !== 0 || range[1] !== 4000) {
            chips.push({
                label: `Fee: €${range[0]} - €${range[1]}`,
                onClear: () => setRange([0, 4000]),
            });
        }

        return chips;
    };

    // función que resetea
    const clearAllFilters = () => {
        setSelectedGender("All");
        setSelectedSpecialty("All");
        setSelectedLanguage("All");
        setSelectedTelemedicine("Any");
        setSelectedHouseCalls("Any");
        setSelectedOnlineBooking("Any");
        setSelectedRating("");
        setRange([0, 4000]);
        // disparar callbacks para recargar resultados
        onFilterGender("All");
        onFilterSpecialty("All");
        onFilterLanguage("All");
        onFilterRange([0, 4000]);
    };

    const activeChips = getActiveFilterChips();

    // Estilos para hover
    const buttonHoverStyle = {
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer'
    };

    return (
        <>
            <div className="filter-container py-3">
                <div class="row align-items-center">

                    <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
                        <div class="form-group d-flex align-items-center flex-row-reverse position-relative">
                            <input
                                type="text"
                                onChange={e => onSearch(e.target.value)}
                                placeholder="Search doctors..."
                                className="form-control ps-2 bg-transparent border-0 shadow-none"
                            />
                            <button type="submit" className="p-0 bg-transparent border-0">
                                <span className="d-block material-symbols-outlined icon-lg">search</span>
                            </button>
                        </div>
                    </div>

                    <div className="col-md-7 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2 gy-3 flex-wrap mt-3">
                        {/* Botones de acciones / filtros / añadir */}
                        <Actions className="btn btn-outline-secondary dropdown-toggle btn-hover-dark" style={buttonHoverStyle} />

            
                        {/* Botón principal de filtros */}
<Link 
    to="#" 
    className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative" 
    type="button" 
    data-bs-toggle="offcanvas"
    data-bs-target="#filtro"
    aria-controls="offcanvasRight"
>
    <div className="filter_text d-flex align-items-center gap-1">
        <span className="d-block material-symbols-outlined icon-md">tune</span>
        <span className="d-block">Filter</span>
    </div>
    {/* Show badge only if there are active filters */}
    {getActiveFilterCount() > 0 && (
        <span 
            className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary" 
            style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
        >
            {getActiveFilterCount()}
        </span>
    )}
</Link>
                    

                        {/* Add New button */}
                        <Link to="#" 
                            className="btn btn-primary addnewbtn d-flex align-items-center gap-1" 
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#addNew"
                            aria-controls="offcanvasRight"
                        >
                            <span className="d-block material-symbols-outlined icon-md">add</span>
                            <span className="d-block">Add New</span>
                        </Link>
                    </div>

                </div>

            </div>

        

            {/* CHIPS + CLEAR ALL */}
            {activeChips.length > 0 && (
                <div className="d-flex align-items-center justify-content-between px-4 pb-3">
                    {/* Izquierda: título + chips */}
                    <div className="d-flex align-items-center gap-3">
                        <strong style={{ whiteSpace: "nowrap" }}>Active Filters:</strong>
                        <div className="d-flex flex-wrap gap-2">
                            {activeChips.map((chip, idx) => (
                                <div
                                    key={idx}
                                    className="d-flex align-items-center px-3 py-1 rounded-pill bg-light border chip-hover"
                                    style={{ fontSize: "14px", ...buttonHoverStyle }}
                                >
                                    {chip.label}
                                    <button
                                        className="btn btn-sm btn-link text-dark ms-2 p-0 btn-link-hover"
                                        style={{
                                            textDecoration: "none",
                                            fontSize: "16px",
                                            lineHeight: 1,
                                            ...buttonHoverStyle
                                        }}
                                        onClick={chip.onClear}
                                    >
                                        &times;
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Derecha: Clear All */}
                    <button
                        className="btn btn-link text-decoration-none btn-link-hover"
                        style={{ fontSize: "14px", ...buttonHoverStyle }}
                        onClick={clearAllFilters}
                    >
                        Clear All
                    </button>
                </div>
            )}


            {/* Panel de filtros */}
            <Filter
                selectedGender={selectedGender}
                setSelectedGender={setSelectedGender}
                selectedSpecialty={selectedSpecialty}
                setSelectedSpecialty={setSelectedSpecialty}
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
                selectedTelemedicine={selectedTelemedicine}
                setSelectedTelemedicine={setSelectedTelemedicine}
                selectedHouseCalls={selectedHouseCalls}
                setSelectedHouseCalls={setSelectedHouseCalls}
                selectedOnlineBooking={selectedOnlineBooking}
                setSelectedOnlineBooking={setSelectedOnlineBooking}
                selectedRating={selectedRating}
                setSelectedRating={setSelectedRating}
                range={range}
                setRange={setRange}
                onApplyGender={onFilterGender}
                onApplySpecialty={onFilterSpecialty}
                onApplyLanguage={onFilterLanguage}
                onApplyRange={onFilterRange}
            />

            <AddNew />
        </>
    );
}

export default DoctorDetails;